
import { defineComponent, PropType } from "vue";
import InputText from "primevue/inputtext";
import Divider from "primevue/divider";
export default defineComponent({
  name: "CompentencyHeaderTitle",
  props: {
    items: Array as PropType<any[]>,
  },
  setup(props) {
    console.log("items " + props.items);
  },
});
